import React from 'react';
import AgeConfirmation from './AgeConfirmation';
import TermsOfUseCheckbox from './TermsOfUseCheckbox';
import PrimaryButton from '../../../view/common/component/PrimaryButton';

export default function ExistingUserPage1({
    isOver16,
    selectUserOver16,
    selectUserUnder16,
    hasAgeConfirmationError,
    isChecked,
    toggleIsChecked,
    hasCheckboxError,
    onSubmit,
    isSubmitting
}) {
    return (
        <div>
            <h2 className="terms-of-use-title">
                {` We've updated our Terms of Use and Privacy Policy`}
            </h2>
            <div className="paragraph-padding">
                <AgeConfirmation
                    isOver16={isOver16}
                    selectIsOver16={selectUserOver16}
                    selectIsUnder16={selectUserUnder16}
                    hasError={hasAgeConfirmationError}
                />
                <TermsOfUseCheckbox
                    isDisabled={isOver16 === null || !isOver16}
                    hasAgreed={isChecked}
                    onChange={toggleIsChecked}
                    hasAgreedError={hasCheckboxError}
                />
            </div>
            <div>
                <PrimaryButton
                    onClick={onSubmit}
                    showActivity={isSubmitting}
                    className="wide-button"
                    testid="page-1"
                >
                    Submit
                </PrimaryButton>
            </div>
        </div>
    );
}
